import React, { Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { ordersService } from './ordersService';
import { Spinner } from '@ami/react/core';
//import './OrderViewPage.scss';
import { DragDropContext } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend'
import moment from 'moment';
import {
  OrderView,
  ShipmentStatus,
  OrderShipment,
} from '../orders/order';
import { ProductConfiguration } from '../products/productConfiguration';

import ManageShipmentComponent from './components/view/shipments/ManageShipmentComponent'




class ManageShipmentPageComponent extends React.Component {
  constructor(props) {
    super(props);    
  }
  state = {
    order: null, 
    productConfiguration: null,
    editingId: undefined,
  };

  async componentDidMount() {
    this.setState({
      productConfiguration: await ProductConfiguration.get(),
    });
    this.loadOrder();
  }

  loadOrder = async () => {   
    this.setState({
      order: await ordersService.getViewById(this.props.match.params.id),
    });     
  };

  navigateToOrderDetails = () => {
    const { order } = this.state;  
    this.props.history.push('/orders/view/' + order.id);
  };

  
  handleShipmentSelect(shipmentId) {
    this.setState({ editingId: shipmentId });
  }
  handleOnRemove = (shipmentToDelete) => {
    this.setState({ shipmentToDelete });
  };

  handleShipmentCancel() {
    this.setState({ editingId: undefined });
  }
  moveProduct = (productId, shipmentId) => {
    const { order } = this.state;
    const lineItem = order.lineItems.find((x) => x.id === productId);
    lineItem.shipmentId = shipmentId;
    this.setState({ order });
  };

  render() {
    const { order, productConfiguration } =
      this.state;

    if (!order || !productConfiguration) {
      return (
        <div className="container text-center">
          <h4 className="mt-5 mb-2">Loading</h4>
          <Spinner show={true} size="fa-5x" />
        </div>
      );
    }
  
    return (   
      <div className="container">      
         <ManageShipmentComponent
          order={order}
          onChanged={this.navigateToOrderDetails}
          onCancel ={this.navigateToOrderDetails}
          productConfiguration={productConfiguration}
        />
      </div>
    );
  }
}

const ManageShipmentPage = withRouter(ManageShipmentPageComponent);
export { ManageShipmentPage };
